import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { TranslateService } from '../../services/translate/translate.service';
import { ContainPopover } from '../../interfaces/contain-popover.interface';
import { Modules } from '../../interfaces/sidebar/modules.interface';
import { ScreenService } from '../../services/screenApp/screen.service';
import { Subscription } from 'rxjs';
import { SettingModules } from '../../interfaces/settings-modules.interface';
import { SidebarCore } from '../../interfaces/sidebar-core.interface';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { ModulesMangosI } from '../../interfaces/modules-mango.interface';
import { MatDialog } from '@angular/material/dialog';
import { ModalVersionComponent } from '../../components/modal-version/modal-version.component';
import { IPkSk } from '../../interfaces/versions.interface';
import { MangoLayoutService } from '../../mango-layout.service';
import { Router } from '@angular/router';
@Component({
  selector: 'mg-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnChanges, OnDestroy {
  @Input() version: string = '0.0.0';
  @Input() listSidebar: Modules[] = [];
  @Input() statusMenu = false;
  @Input() modulesToolbar: ModulesMangosI[] = [];
  @Input() ids!: IPkSk;
  @Input() showModules: boolean = true;

  @Output() menu = new EventEmitter<boolean>();
  modules: Modules[] = [];
  icon: string = '';
  statusSelected = '';
  viewTablet = false;
  language!: string;
  settings: SettingModules[] = [];
  sessions: ContainPopover[] = [];
  modulesSidebar: SidebarCore[] = [];
  subscriptionToggle!: Subscription;
  subscriptionModules!: Subscription;
  subscriptionScreen!: Subscription;
  routerName$!: Subscription;
  defaultVisibleLanguage = false;
  statusPopoverLanguage = false;
  newVersion: boolean = false;
  installEvent: any = null;

  constructor(
    private auth: AuthenticationService,
    private translate: TranslateService,
    private screenService: ScreenService,
    private dialog: MatDialog,
    private mangoLayoutService: MangoLayoutService,
    private router: Router
  ) {
    this.screenService.init();
  }

  ngOnInit(): void {
    // this.getSubscription();
    const getVersion = sessionStorage.getItem('version') || '';
    if (getVersion !== this.version) {
      this.newVersion = true;
    }
    this.getTranslate();
  }
  ngOnChanges(changes: SimpleChanges): void {
    changes['listSidebar'] && this.getUpdateModules();
  }

  changeMenu() {
    this.statusMenu = !this.statusMenu;
    this.menu.emit(this.statusMenu);
    this.modules = this.modules.map((module) => ({
      ...module,
      expanded: false,
    }));
  }
  selectedModule() {
    if (window.innerWidth < 768) {
      this.statusMenu = false;
      this.menu.emit(this.statusMenu);
    }
  }
  changeLanguage(event: any) {
    const language = event.target.value;
    this.translate.update(language);
  }

  logout() {
    this.mangoLayoutService.emitActionCore('logout', true);
    this.auth.logout();
  }

  closeTraslate(item: any) {
    if (this.statusPopoverLanguage === true) {
      this.statusPopoverLanguage = false;
    } else {
      this.defaultVisibleLanguage = item;
    }
  }

  isRootUrl(module: Modules): boolean {
    return this.router.url.includes(module.route);
  }

  toggleSubmenu(item: any, event: Event): void {
    event.stopPropagation(); // Evita que se dispare el evento del módulo padre
    item.expanded = !item.expanded;
    setTimeout(() => {
      if (window.innerWidth > 768) {
        this.statusMenu = true;
        this.menu.emit(this.statusMenu);
      }
    }, 10);
  }

  togglePopoverLanguage() {
    this.defaultVisibleLanguage = !this.defaultVisibleLanguage;
    if (this.defaultVisibleLanguage === true) {
      this.statusPopoverLanguage = true;
    }
  }

  moduleMangoSelected(module: ModulesMangosI) {
    if (!location.hostname.includes(module.mainUrl)) {
      window.open(`https://${module.mainUrl?.trim()}`);
    }
    this.selectedModule();
  }

  getTranslate() {
    this.translate.init('core').subscribe((core) => {
      this.settings = core.settings;
      this.modulesSidebar = core.sidebar;
      this.getUpdateModules();
    });
  }

  getUpdateModules() {
    this.modules = [];
    this.listSidebar.forEach((titleSidebar) => {
      const element = this.modulesSidebar.find(
        (module) => module.id === titleSidebar.id
      );
      if (element?.id) {
        const { title, ...contentSidebar } = titleSidebar;

        let children = titleSidebar.children || [];
        if (children.length > 0) {
          children = children.map((child) => {
            const moduleChild = this.modulesSidebar.find(
              (module) => module.id === child.id
            );
            if (moduleChild?.id) {
              const { title, ...contentChild } = child;
              return {
                title: moduleChild.title,
                ...contentChild,
              };
            }
            return child;
          });
        }
        const module: Modules = {
          title: element.title,
          ...contentSidebar,
          children,
        };
        this.modules.push(module);
      }
    });
    this.modules = [...this.modules];
  }

  installApp() {
    if (this.installEvent) {
      this.installEvent.prompt();
      this.installEvent.userChoice.then((rta: any) => {
        if (rta.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
      });
    }
  }

  @HostListener('window: beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: Event) {
    event.preventDefault();
    this.installEvent = event;
  }

  openModalVersion() {
    if (this.ids && this.ids?.pk && this.ids?.sk) {
      sessionStorage.setItem('version', this.version);
      this.newVersion = false;
      this.dialog.open(ModalVersionComponent, {
        minHeight: '286px',
        width: '500px',
        maxWidth: '100vw',
        maxHeight: '100dvh',
        data: { version: this.version, ids: this.ids },
      });
    }
  }
  ngOnDestroy(): void {
    this.subscriptionToggle?.unsubscribe();
    this.subscriptionModules?.unsubscribe();
    this.subscriptionScreen?.unsubscribe();
    this.routerName$?.unsubscribe();
  }
}
